import { useEffect, useState } from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import { captureException } from "@sentry/react";

import CreateAutoresponder from "./CreateAutoresponder";

export default ({ refetch, closeCreateAutoresponderModal }) => {
  const [name, setName] = useState("");
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [warnings, setWarnings] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleInputChange = (e) => {
    setName(e.target.value);
  };

  const CREATE_AUTORESPONDER = gql`
    mutation CreateAutoresponder($name: String!) {
      createAutoresponder(name: $name) {
        resultCode
      }
    }
  `;

  const [createAutoresponder] = useMutation(CREATE_AUTORESPONDER);

  const onCreateAutoresponder = async () => {
    try {
      if (loadingCreate) return;

      if (name.length < 1) {
        setWarnings(["name"]);
        return;
      }

      setWarnings([]);
      setErrorMessage(null);

      setLoadingCreate(true);

      const result = await createAutoresponder({
        variables: {
          name,
        },
      });

      const { resultCode } = result.data.createAutoresponder;
      console.log({ resultCode });

      if (resultCode === 7) {
        // too many responders
        setErrorMessage(
          "You can have a maximum of 10 autoresponders. Please delete an older responder before creating a new one."
        );
        setLoadingCreate(false);
        return;
      }

      if (resultCode !== 0) {
        setErrorMessage(
          "An error occurred while submitting the request. Please try again or contact support."
        );
        setLoadingCreate(false);
        return;
      }

      refetch();
      closeCreateAutoresponderModal();

      setLoadingCreate(false);
    } catch (error) {
      console.log("error createAutoresponder", error);
      captureException(error);
      setLoadingCreate(false);
      return;
    }
  };

  return (
    <CreateAutoresponder
      name={name}
      handleInputChange={handleInputChange}
      onCreateAutoresponder={onCreateAutoresponder}
      loadingCreate={loadingCreate}
      warnings={warnings}
      errorMessage={errorMessage}
    />
  );
};
